export default "__VITE_ASSET__Dz0oLDn0__"